<template lang="pug">
    #BoxH
        ul
            li(v-for="item in boxes")
                    .img
                        img(:src="item.image").image
                    .container
                        h3 {{ item.title }}   
                        p {{ item.text }}
                        a(:href="item.link")
                            span {{ item.call }}

</template>

<script>
import { props } from '@/mixins/component';

export default {
    name: "boxH",
    props,
    data() {
        return {
            boxes: []
        }
    },
    mounted() {
        this.boxes = this.contents.content
    }
}
</script>

<style lang="stylus" scoped src="./BoxH.styl"></style>
